export default function auth() {
  const user = JSON.parse(localStorage.getItem('user'))
  // console.log(user)
  if (user && user.payload.accessToken) {
    // for Spring Boot
    return {
      Authorization: 'Bearer ' + user.payload.accessToken,
    }
    // for Node.js Express
    // return {
    //   'x-access-token': user.accessToken,
    // }
  } else {
    return {}
  }
}
